D.addEventListener("DOMContentLoaded", function() {

	//fixed header
		const fixedHeader = () => {
			let header = D.querySelector('.js-header');
			let scrollBarPosition = W.pageYOffset | D.body.scrollTop;

			if( scrollBarPosition  > 200) {
				header.classList.add("is-fixed")
			} else {
				header.classList.remove("is-fixed")
			}
		}
		W.addEventListener("scroll", fixedHeader);


	//header memu scroll to
		const sections = D.querySelectorAll(".js-menu-section");

		W.addEventListener("scroll", navHighlighter);

		function navHighlighter() {
			let scrollY = W.pageYOffset;
	
			sections.forEach(current => {
				const sectionHeight = current.offsetHeight;
				const sectionTop = current.offsetTop - 90;
				let sectionId = current.getAttribute("id");


				if (
					scrollY > sectionTop &&
					scrollY <= sectionTop + sectionHeight
				) {
					D.querySelector(`.js-scrollto[href*= ${sectionId} ]`).classList.add("is-active");
				} else {
					D.querySelector(`.js-scrollto[href*= ${sectionId} ]`).classList.remove("is-active");
				}
			});
		}

		let menuLink = D.querySelectorAll('.js-scrollto');
		
		menuLink.forEach(elem => {
			elem.addEventListener('click', e => {
				e.preventDefault();

				let block = D.querySelector(elem.getAttribute('href')),
				offset = elem.dataset.offset ? parseInt(elem.dataset.offset) : 0,
				bodyOffset = B.getBoundingClientRect().top;
				W.scrollTo({
					top: block.getBoundingClientRect().top - bodyOffset + offset - 60,
					behavior: 'smooth'
				}); 
			});
		});


	//mobile menu
		let nav = D.querySelector('.js-nav'),
			burger = D.querySelector('.js-burger');

		const mobileMenu = () => {
			if (W.innerWidth <= 992) {
				nav.classList.toggle('is-active');
				burger.classList.toggle('is-active');
			}
		}

		burger.addEventListener('click', mobileMenu);
		for (let item of menuLink) {
			item.addEventListener('click', mobileMenu);
		}


});

